'use client';

import React from 'react';

import { Offer } from '@depop/web-thrift-ui/Icons/Offer';
import { useTranslations } from 'next-intl';

import { NudgePill, type NudgePillProps } from '@/components/NudgePill';
import { getComputedNudgesCount } from '@/modules/nudges/helpers/getComputedNudgesCount';

type Props = Pick<NudgePillProps, 'className'> & {
  count?: number;
};

export function OffersSentNudge({ count, className }: Props) {
  const t = useTranslations('offers');

  if (!count) {
    return null;
  }

  return (
    <NudgePill
      testId="OffersSentNudgeWrapper"
      className={className}
      icon={<Offer size="md" />}
      text={t('OffersNudge', {
        count: getComputedNudgesCount(count),
      })}
    />
  );
}
